import { render, staticRenderFns } from "./HeaderGame.vue?vue&type=template&id=f2acd230&scoped=true&"
import script from "./HeaderGame.vue?vue&type=script&lang=ts&"
export * from "./HeaderGame.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderGame.vue?vue&type=style&index=0&id=f2acd230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2acd230",
  null
  
)

export default component.exports